import { Navigate, useParams } from 'react-router-dom';
import type { BuildingZone } from '@kaeliux/shared';
import { useTeamPlanetSession } from '../contexts/TeamPlanetContext';
import { usePlanetView } from '../contexts/PlanetViewContext';
import { ZoneBuildingsView } from './ZonePage';
import TeamPlanetReadOnlyNotice from '../components/teamPlanet/TeamPlanetReadOnlyNotice';

const ZONE_TITLES: Record<BuildingZone, string> = {
    resource: 'Team Planet Resource Zone',
    industry: 'Team Planet Industry Zone',
    military: 'Team Planet Military Zone',
};

function isBuildingZone(value: string | undefined): value is BuildingZone {
    return value === 'resource' || value === 'industry' || value === 'military';
}

export default function TeamPlanetZonePage() {
    const { zoneId } = useParams();
    const { teamPlanet } = useTeamPlanetSession();
    const { canManage } = usePlanetView();

    if (!isBuildingZone(zoneId)) return <Navigate to="/team-planet" replace />;

    return (
        <>
            {!canManage && (
                <div className="w-full max-w-7xl mx-auto px-4 pt-4">
                    <TeamPlanetReadOnlyNotice />
                </div>
            )}
            <ZoneBuildingsView zone={zoneId} planet={teamPlanet} isLoading={false} title={ZONE_TITLES[zoneId]} />
        </>
    );
}
